import { render, staticRenderFns } from "./feedbackPage.vue?vue&type=template&id=3338a71e"
import script from "./feedbackPage.vue?vue&type=script&lang=js"
export * from "./feedbackPage.vue?vue&type=script&lang=js"
import style0 from "./feedbackPage.vue?vue&type=style&index=0&id=3338a71e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports